import { Translation } from "@payair/e-com-common-sdk/core/LanguageHandler"

const polishLanguage: Translation = {
  welcomeToClickToPay: "Witaj w Click to Pay",
  welcomeBackToClickToPay: "Witaj ponownie w Click to Pay",
  fastSecureOnlineCheckout: "Szybkie i bezpieczne płatności internetowe",
  weAccept: "Akceptujemy",
  getStarted: "Rozpocznij",
  emailAddress: "Adres e-mail",
  continue: "Kontynuuj",
  verify: "Sprawdź",
  consentText:
    "Wyrażam zgodę na udostępnienie moich danych usłudze Click to Pay, aby umożliwić mi zarejestrowanie się w celu szybszej realizacji transakcji",
  rememberMe: "Zapamiętaj mnie",
  rememberMeInBrowser: "Zapamiętaj mnie w tej przeglądarce",
  rememberMeMoreInformation: "Więcej informacji o zapamiętaniu tej przeglądarki",
  rememberMeTooltipPrimary:
    "Po zapamiętaniu pominiesz weryfikację i uzyskasz bezpieczny dostęp do zapisanych kart podczas płacenia przez Click to Pay.",
  rememberMeTooltipWarning:
    "Nie zalecamy tej opcji na urządzeniach publicznych ani współdzielonych, ponieważ wykorzystuje pliki cookie.",
  notYou: "Nie ty?",
  clickToPay: "Click to Pay",
  existingAccount: "Wygląda na to, że już masz profil Click to Pay",
  otpInformation: "Podaj kod wysłany do: ",
  otpTooShortCode: "Podaj prawidłowy kod (6 cyfr)",
  resend: "Wyślij ponownie",
  changeChannel: "Kontynuuj inną metodą",
  selectCard: "Wybierz kartę do zapłaty",
  addCard: "Dodaj nową kartę",
  expired: "wygasła",
  addToCTP: "Dodaj do Click to Pay",
  selectCardButton: "Wybierz kartę",
  changeOTPChannel: {
    subtitle: "Click another way",
    option1: "Text another code to",
    option2: "E-mail another code to",
    option3: "Pay another way",
  },
  cardSwitchUser: "By zobaczyć Twoje zapisane karty",
  signIn: "zaloguj się.",
  addNewCard: "Dodaj nową kartę",
  uncheckedConstentWarning:
    "To pole jest wymagane. Jeśli nie wyrażasz zgody, zamknij to okno i wybierz inną metodę płatności.",
  processing: "Przetwarzanie",
  createAccount: "Utwórz konto",
  countryRegion: "Kraj",
  enterOrSelect: "Wpisz lub wybierz",
  storeCard: "Zapisz kartę",
  storeCardDescription: "Potrzebujemy dodatkowych informacji, aby zapisać Twoją kartę.",
  storeAndPay: "Zapisz kartę i zapłać",
  goBack: "Wróć",
  storeCardLegalBeforeTerms: "Kontynuując, akceptujesz ",
  storeCardLegalBetweenLinks:
    " sieci {network} i przyjmujesz do wiadomości, że Twoje dane będą przetwarzane zgodnie z dokumentem ",
  storeCardLegalAfterPrivacy: ".",
  reviewYourDetails: "Sprawdź swoje dane...",
  captionVerification:
    "Twój adres e-mail lub numer telefonu zostanie użyty do weryfikacji. Mogą obowiązywać opłaty za wiadomości lub transmisję danych.",
  terms: "Warunki",
  privacyNotice: "Informacja o ochronie prywatności",
  opensInNewWindow: "Otwiera się w nowym oknie",
  wrongFormat: "Nieprawidłowy format",
  nameWrongFormat: "Użyj tylko liter, spacji, apostrofów lub łączników",
  requiredField: "To pole jest wymagane",
  allowedLengthRange: "Wpisz od {min} do {max} znaków",
  maximumLength: "Maksymalna długość to {max} znaków",
  invalidLength: "Nieprawidłowa długość",
  phoneCountryCode: "Kod kraju numeru telefonu",
  phoneNumber: "Numer telefonu",
  dataDisclosure:
    "Click to Pay będzie używać tych informacji, aby sprawdzić, czy masz zapisane karty. Jednorazowy kod dostępu może zostać wysłany na ten numer komórkowy, aby potwierdzić, że to ty. Mogą obowiązywać opłaty za wiadomości/dane.",
  firstName: "Imię",
  lastName: "Nazwisko",
  sms: "SMS",
  email: "E-mail",
  saveCardAndPay: "Zapisz kartę i zapłać",
  unexpectedError: "Coś poszło nie tak. Spróbuj ponownie.",
}

export default polishLanguage
